<template>
	<component
    :is="tag"
    class="button"
    :href="url || href"
    :type="!url && type"
    :target="url || href ? target : null"
    :disabled="disabled"
    :class="[
			`button--${level}`,
      ...variants.map(variant => `button--${variant}`),
      { 'button--icon': icon },
      { 'button--arrow': arrow },
      { 'button--no-text': !text },
      { 'button--reverse': reverse },
      { 'button--small': small },
    ]"
    @click="onClick"
  >
		<component
      class="button__icon"
			v-if="icon"
			:is="iconComponent(icon)"
		/>
    <span
      class="button__text"
      v-if="text"
      v-html="text"
    />
  </component>
</template>

<script>
import {toPascal} from '@/utils/convertcase';

export default {
	props: {
		disabled: Boolean,
		href: String,
		target: String,
		url: String,
		type: String,
		icon: String,
		text: String,
    small: Boolean,
		arrow: Boolean,
		reverse: Boolean,
		level: {
			type: String,
			default: 'primary',
		},
		variants: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			tag: this.url || this.href ? 'a' : 'button'
		};
	},
	computed: {
		arrowComponent() {
			const icon = this.reverse ? 'mid-circle-chevron-left' : 'mid-circle-chevron-right';
			return `SVG${toPascal(icon)}`;
		},
	},
	methods: {
		onClick(e) {
			this.$emit('click', e);
		}
	}
}
</script>

<style>

</style>
